























import { Component, Prop, Inject, Mixins } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import { FormDataType } from '@/pages/profile/store';
import {
  MentoringProgramForm,
  MentoringMeeting,
  MeetingFormData,
} from './components';
import Infotext from '@/components/parts/infotext';
import { LoaderMixin, StatusEnum } from '@/pages/profile/mixins';
import { mentoringService } from '@/services';
import meteengFormDataParcer from './dataparser';
import { IMeetingFormData, IMeetingFormPayload } from './types';

@Component({
  components: {
    Infotext,
    MentoringMeeting,
    MentoringProgramForm,
  },
})
export default class MentoringModal extends Mixins(LoaderMixin) {
  @Inject() $api: AxiosInstance;

  @Prop({ type: Object, default: null })
  readonly formData!: FormDataType;

  errorMessage: string = '';
  meeting: any = {};

  get meetingStatus() {
    return this.formData && this.formData.status;
  }

  get isOpen() {
    return this.meetingStatus === 'open';
  }

  get index() {
    return this.formData && this.formData.index;
  }

  mounted() {
    if (this.isOpen) {
      this.getData();
    } else {
      this.status = StatusEnum.SUCCESS;
    }
  }

  beforeDestroy() {
    this.reset();
  }

  async getData(): Promise<void> {
    this.status = StatusEnum.LOADING;

    try {
      const { $api, formData } = this;
      if (formData) {
        const { id } = formData;
        const { data } = await mentoringService($api).getMeeting(id);
        this.meeting = data;
        this.status = StatusEnum.SUCCESS;
      }
    } catch (err) {
      this.errorMessage = 'Ошибка';
      this.status = StatusEnum.ERROR;
    }
  }

  async submitMeetingForm(payload: MeetingFormData) {
    this.status = StatusEnum.LOADING;

    try {
      const { $api, formData } = this;

      if (formData) {
        const { id, kid_id } = formData;
        const value: IMeetingFormData = meteengFormDataParcer({
          ...payload,
          id,
          kid_id,
        } as IMeetingFormPayload);
        const { data } = await mentoringService($api).postMeeting(value);
        this.meeting = data;
        this.status = StatusEnum.SUCCESS;
      }
    } catch (err) {
      this.errorMessage = 'Ошибка';
      this.status = StatusEnum.ERROR;
    }
  }

  reset() {
    this.errorMessage = '';
    this.meeting = [];
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/modal/MentoringModal.vue